import { formatInteger } from '../../demo/format'
import type { Objective } from '../../demo/types'
import { Card, GlossaryText } from '../../ui'
import styles from './CreatePage.module.css'
import { createTakeoverCopy } from './copy'
import { FORECAST_BY_OBJECTIVE, PLAN_DRAFT } from './planDraftData'

interface SummaryCardProps {
  objective: Objective
}

export function SummaryCard({ objective }: SummaryCardProps) {
  const forecast = FORECAST_BY_OBJECTIVE[objective]
  return (
    <Card className={styles.takeoverCard} data-scope="plan-forecast">
      <div className={styles.cardHead}><h3>{createTakeoverCopy.forecastCard.title}</h3></div>
      <div className={styles.cardBody}>
        <p className={`${styles.mono} ${styles.forecastValue}`} data-role="forecast-value">{formatInteger(forecast.value)} {forecast.unit}</p>
        <p className={`${styles.tiny} ${styles.muted} ${styles.forecastWindow}`}>{createTakeoverCopy.forecastCard.window.replace('{days}', String(PLAN_DRAFT.forecast.windowDays))}</p>
        <p className={styles.forecastBasis} data-role="forecast-basis"><GlossaryText text={PLAN_DRAFT.forecast.basis} /></p>
      </div>
    </Card>
  )
}
